import React from 'react';
export var Context = React.createContext({
  selectedValue: '',
  size: 'medium',
  onChange: function onChange() {},
  disabled: false,
  name: ''
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/ButtonToggle/context.js
// module id = 399
// module chunks = 0